<template>
  <div>
    <div class="modal inmodal fade"
         :class="[store.modal.wrapperClass, {'in': enterAnimation}]"
         tabindex="-1"
         role="dialog"
         aria-hidden="true"
         :style="modalStyle">
      <div class="modal-dialog"
           :class="store.modal.size">
        <component :is="store.modal.childVue" />
      </div>
    </div>
    <div class="modal-backdrop fade"
         :class="{'in': enterAnimation}"></div>
  </div>
</template>

<script>
  import AddCarRegistrationData from './modals/AddCarRegistrationData'
  import DocumentValidation from './modals/DocumentValidation'
  import AddVehicle from './modals/AddVehicle'
  import AddCustomer from './modals/AddCustomer'
  import AddParticipant from './modals/AddParticipant'
  import CreditWallet from './modals/CreditWallet'
  import Confirm from './modals/Confirm'
  import Error from './modals/Error'
  import NonSold from './modals/NonSold.vue'
  import Reason from './modals/Reason.vue'
  import Replan from './modals/Replan.vue'
  import ReplanReason from './modals/ReplanReasons.vue'
  import SoldByFV from './modals/SoldByFV.vue'
  import deleteOrder from './modals/Delete.vue'
  import CancelReason from './modals/CancelReason.vue'
  import Commercial from './modals/Commercial.vue'
  import PurchaseOrderQuestions from './modals/PurchaseOrderQuestions.vue'
  import store from '../config/store'

  export default {
    components: {
      AddCarRegistrationData,
      AddVehicle,
      AddCustomer,
      AddParticipant,
      CreditWallet,
      DocumentValidation,
      Error,
      Confirm,
      NonSold,
      Reason,
      Replan,
      ReplanReason,
      SoldByFV,
      deleteOrder,
      CancelReason,
      Commercial,
      PurchaseOrderQuestions
    },

    data: () => ({
      store,
      enterAnimation: false,
    }),

    mounted () {
      setTimeout(() => {
        this.enterAnimation = true
      }, 30)

      this.$bus.$on('close-modal', this.onCloseModal)
    },

    destroyed () {
      this.$bus.$off('close-modal', this.onCloseModal)
    },

    computed: {
      modalStyle () {
        if (store.modal.active) {
          return 'display: block; overflow: scroll;'
        }
        return 'display: none;'
      }
    },
    methods: {
      onCloseModal () {
        this.enterAnimation = false
        setTimeout(() => {
          store.modal.active = false
        }, 200)
      }
    }
  }
</script>